import { z } from 'zod';
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
/**
 * A tenancy the broker already has running, added so the renewal radar knows it. It records who, which
 * flat, the rent, the term and the brokerage the broker would earn again on a renewal.
 */
export const backfillRowSchema = z.object({
    tenantName: z.string().trim().min(2).max(80),
    tenantPhone: z.string().trim().min(1).max(20),
    ownerName: z.string().trim().min(1).max(80).nullable().optional(),
    ownerPhone: z.string().trim().min(1).max(20).nullable().optional(),
    propertyId: z.string().uuid(),
    rentPaise: z.number().int().min(100).max(Number.MAX_SAFE_INTEGER),
    startDate: isoDate,
    endDate: isoDate,
    brokeragePaise: z.number().int().min(0).max(Number.MAX_SAFE_INTEGER).nullable().optional(),
});
export const MAX_BACKFILL_ROWS = 50;
/** `dryRun` checks every row and writes nothing; a real run writes all rows or none. */
export const backfillSchema = z.object({
    rows: z.array(backfillRowSchema).min(1).max(MAX_BACKFILL_ROWS),
    dryRun: z.boolean().optional(),
});
/** Months from the first day to the day after the last day, at least one: the term of an old agreement. */
export function termMonthsBetween(startDate, endDate) {
    const [sy, sm, sd] = startDate.split('-').map(Number);
    const after = new Date(`${endDate}T00:00:00Z`);
    after.setUTCDate(after.getUTCDate() + 1);
    const whole = (after.getUTCFullYear() - sy) * 12 +
        (after.getUTCMonth() + 1 - sm) -
        (after.getUTCDate() >= sd ? 0 : 1);
    return Math.max(1, whole);
}
//# sourceMappingURL=backfill.js.map